import { BarcodeOptions } from './types';

export interface SavedBarcodePreset {
  id: string;
  name: string;
  options: BarcodeOptions;
  locked: boolean;
}

const PRESETS_STORAGE_KEY = 'barcode-presets';

export function loadBarcodePresets(): SavedBarcodePreset[] {
  try {
    const raw = localStorage.getItem(PRESETS_STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function persistBarcodePresets(presets: SavedBarcodePreset[]): void {
  localStorage.setItem(PRESETS_STORAGE_KEY, JSON.stringify(presets));
}
